import { UploaderX } from "laravel-ngx-uploadx";

export class UploaderExt extends UploaderX {
  setAuth(encoded: string) {
    this.headers['X-XSRF-TOKEN'] = `${encoded}`;
  }

  protected async getChunk() {
    this.encryptionHandler.resetIV()
    await this.encryptionHandler.setKey(this.fileParams.fileKey);
    const start = this.offset as number;
    const end = this.chunkSize ? Math.min(start + this.chunkSize, this.size) : this.size;
    const body = this.file.slice(this.offset, end);
    const bodyEnc = await this.encryptionHandler.encryptBlob(body)
    const newBody = new Blob([bodyEnc])
    const fileName = this.file.name;
    const fileType = this.file.type;
    return { start, end, body: newBody, fileName, fileType };
  }
}